import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef} from '../../../lib/react/higher-order-components';
import {OEViewType, OEFreePremiumViewTypes} from '../../../lib/oe-types';
import OENotification from '../../../lib/notification/oe-notification';
import {OEDefaultConfigFactory} from '../../oe-default-configs';
import OEFreePremiumViewStd from './oe-free-premium-view-std';
import OEFreePremiumViewTest from './oe-free-premium-view-test';

export function OEFreePremiumViewFactory(props) {
    let {fref, config, ...rest} = props;
    config = config || OEDefaultConfigFactory.freePremiumView();

    const openFn = (sender, isOpen) => {
        if(!props.appComponent || !props.appComponent.uiLayer) return;
        props.appComponent.uiLayer.notificationCenter.post(OENotification.viewOpenStateChanged, {
            type:   OEViewType.freePremium,
            isOpen: isOpen,
            sender: sender
        });
    };

    if(config.type == OEFreePremiumViewTypes.std)   {
        return <OEFreePremiumViewStd {...rest} config={config} ref={fref} onOpenStateChanged={openFn}/>
    } else if(config.type == OEFreePremiumViewTypes.test)   {
        return <OEFreePremiumViewTest {...rest} config={config} ref={fref} onOpenStateChanged={openFn}/>
    }

    return null;
}

OEFreePremiumViewFactory.defaultProps = {
    moduleId:           '',
    config:             OEDefaultConfigFactory.freePremiumView()
};

OEFreePremiumViewFactory.propTypes = {
    moduleId:           PropTypes.string,
    config:             OEDefaultConfigFactory.freePremiumViewDecl
};

//
export default frefFromRef(connectAppEnv((env) => { return {
    version:            env.config.version,
    target:             env.config.target,
    flags:              env.config.module.flags,
    appComponent:       env.component,
    config:             env.config.module.uiLayerConfig.freePremiumView
}})(OEFreePremiumViewFactory));